import { palette } from './theme';

const stylesLetters = {
    errorLetters : {
        color: palette.error.main,
        fontSize: '12px',
        fontStyle: 'bold'
    },
    letrasInfo: {
        color: palette.info.main,
        fontSize: '12px',
    },
};

export default stylesLetters;